import { AlertTriangle, CheckCircle } from 'lucide-react';
import type { SeverityLevel } from './story-utils';

interface StoryMastheadProps {
  restaurantName: string;
  campaignName: string;
  domain: string;
  severity: SeverityLevel;
}

const SEVERITY_CONFIG = {
  critical: { label: 'Critical', className: 'story-severity-critical', Icon: AlertTriangle },
  warning: { label: 'Warning', className: 'story-severity-warning', Icon: AlertTriangle },
  ok: { label: 'Healthy', className: 'story-severity-ok', Icon: CheckCircle },
} as const;

export function StoryMasthead({ restaurantName, campaignName, domain, severity }: StoryMastheadProps) {
  const config = SEVERITY_CONFIG[severity];
  const Icon = config.Icon;

  return (
    <div className="story-masthead story-anim-1">
      <div className="story-masthead-meta">
        <span>{campaignName}</span>
        <div className="story-dot" />
        <a href={`https://${domain}`} target="_blank" rel="noopener noreferrer">{domain}</a>
      </div>
      <div className="story-masthead-row">
        <h1>{restaurantName}</h1>
        <div className={`story-severity ${config.className}`}>
          <Icon size={11} />
          {config.label}
        </div>
      </div>
    </div>
  );
}
